import React from 'react'
import FormHeading from '../../../atoms/FormHeading'
import Form from './Form'

const ForgotPassword = () => {
  return (
    <>
    <FormHeading title='Login with OTP'  description='Enter your email address to receive a One-Time Password.' calledForm='auth'/>
    <Form/>
    </>
  )
}

export default ForgotPassword